// CustConstList?projectId=1

import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchCustConst: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveCustConst: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchCustConstData = createApiThunk("custConst", "fetch")
export const saveCustConstData = createApiThunk("custConst", "save")

// Slice
const custConstSlice = createSlice({
    name: "custConst",
    initialState,

    reducers: {
        resetCustConstState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchCustConst = {
                    ...state.fetchCustConst, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveCustConst = {
                    ...state.saveCustConst, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchCustConstData.pending, (state) => updateState(state, "pending", "fetchCustConst"))
            .addCase(fetchCustConstData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchCustConst", action.payload.data))
            .addCase(fetchCustConstData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchCustConst", action.payload))
            // Save data
            .addCase(saveCustConstData.pending, (state) => updateState(state, "pending", "saveCustConst"))
            .addCase(saveCustConstData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveCustConst", action.payload.data))
            .addCase(saveCustConstData.rejected, (state, action) =>
                updateState(state, "rejected", "saveCustConst", action.payload));
    },
});

export const { resetCustConstState } = custConstSlice.actions;
export default custConstSlice.reducer;
